import { Component, input, output } from '@angular/core'

type EmptyStateMode = 'all' | 'filtered' | 'search'

@Component({
  selector: 'app-events-timeline-empty-state',
  standalone: true,
  templateUrl: './events-timeline-empty-state.component.html',
  styleUrl: './events-timeline-empty-state.component.scss'
})
export class EventsTimelineEmptyStateComponent {
  public readonly mode = input<EmptyStateMode>('all')
  public readonly filterLabel = input('events')
  public readonly imageSrc = input('')
  public readonly heading = input('')
  public readonly showCreateButton = input(false)
  public readonly createButtonLabel = input('Create first event')

  public readonly createClicked = output<void>()

  /**
   * Resolve heading text by empty-state mode.
   */
  public getHeading(): string {
    const customHeading = this.heading().trim()
    if (customHeading) return customHeading
    if (this.mode() === 'search') return 'No events found.'
    if (this.mode() === 'filtered') return `You don’t have any ${this._formatFilterLabel(this.filterLabel())} events yet.`
    return 'No events yet!'
  }

  /**
   * Resolve subheading for all-events empty state only.
   */
  public getSubheading(): string {
    if (this.heading().trim()) return ''
    if (this.mode() !== 'all') return ''
    return 'Start by creating your first event to plan, manage, and track with ease.'
  }

  /**
   * Emit create-event action.
   */
  public onCreateClicked(): void {
    this.createClicked.emit()
  }

  public getImageSrc(): string {
    const customImage = this.imageSrc().trim()
    if (customImage) return customImage
    return this.mode() === 'all' ? 'assets/images/v2/noEvents.svg' : 'assets/images/v2/noEvents2.svg'
  }

  private _formatFilterLabel(label: string): string {
    const trimmedLabel = label.trim()
    if (!trimmedLabel) return 'events'
    if (trimmedLabel.toLowerCase() === 'past') return 'Finished'
    return `${trimmedLabel.charAt(0).toUpperCase()}${trimmedLabel.slice(1)}`
  }
}
